export const STRENGTH_EXERCISE_LIBRARY = [
    // PEITO (Chest)
    {
        id: "supino_reto_barra",
        name: "Supino reto com barra",
        category: "Peito",
        primaryMuscles: ["Peito"],
        secondaryMuscles: ["Tríceps", "Ombros"],
        movementPattern: "Empurrar horizontal",
        equipment: ["Barra", "Banco"],
        difficulty: "Intermediário",
        instructions: "Deite-se no banco, segure a barra com pegada pronada um pouco além da largura dos ombros. Desça a barra até tocar o peito de forma controlada e empurre-a de volta ao topo.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["supino_reto_halteres", "supino_maquina"],
        tags: ["peito", "força", "hipertrofia"],
    },
    {
        id: "supino_inclinado_halteres",
        name: "Supino inclinado com halteres",
        category: "Peito",
        primaryMuscles: ["Peito"],
        secondaryMuscles: ["Tríceps", "Ombros"],
        movementPattern: "Empurrar horizontal",
        equipment: ["Halteres", "Banco Inclinado"],
        difficulty: "Intermediário",
        instructions: "Ajuste o banco para 30-45 graus. Erga os halteres acima do peito e controle a descida mantendo os cotovelos a 45 graus do corpo.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["supino_inclinado_barra", "supino_inclinado_maquina"],
        tags: ["peito superior", "hipertrofia"],
    },
    {
        id: "supino_reto_halteres",
        name: "Supino reto com halteres",
        category: "Peito",
        primaryMuscles: ["Peito"],
        secondaryMuscles: ["Tríceps", "Ombros"],
        movementPattern: "Empurrar horizontal",
        equipment: ["Halteres", "Banco"],
        difficulty: "Intermediário",
        instructions: "Deite no banco com halteres alinhados ao peito. Desça controlando os cotovelos e empurre mantendo punhos firmes.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["supino_reto_barra", "supino_maquina"],
        tags: ["peito", "hipertrofia", "halteres"],
    },
    {
        id: "supino_maquina",
        name: "Supino máquina",
        category: "Peito",
        primaryMuscles: ["Peito"],
        secondaryMuscles: ["Tríceps", "Ombros"],
        movementPattern: "Empurrar horizontal",
        equipment: ["Máquina"],
        difficulty: "Iniciante",
        instructions: "Ajuste o banco para alinhar as manoplas ao peito. Empurre sem travar os cotovelos e controle o retorno.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["supino_reto_barra", "supino_reto_halteres"],
        tags: ["peito", "máquina", "iniciante"],
    },
    {
        id: "crucifixo_cabo",
        name: "Crucifixo na polia (Cross Over)",
        category: "Peito",
        primaryMuscles: ["Peito"],
        secondaryMuscles: ["Ombros"],
        movementPattern: "Isolado Peito",
        equipment: ["Cabo"],
        difficulty: "Intermediário",
        instructions: "Ajuste as polias na altura média. Dê um passo à frente, flexione levemente os cotovelos e faça o movimento de abraço até as mãos se encontrarem no centro.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["crucifixo_halteres", "peck_deck"],
        tags: ["peito", "definição"],
    },
    // COSTAS (Back)
    {
        id: "puxada_alta_pronada",
        name: "Puxada alta (Pulldown) pegada aberta",
        category: "Costas",
        primaryMuscles: ["Costas"],
        secondaryMuscles: ["Bíceps", "Antebraço"],
        movementPattern: "Puxar vertical",
        equipment: ["Máquina", "Cabo"],
        difficulty: "Iniciante",
        instructions: "Segure a barra com pegada pronada bem aberta. Puxe a barra em direção ao peito superior contraindo as escápulas.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["barra_fixa", "puxada_triangulo"],
        tags: ["costas", "dorsal"],
    },
    {
        id: "remada_baixa_triangulo",
        name: "Remada baixa com triângulo",
        category: "Costas",
        primaryMuscles: ["Costas"],
        secondaryMuscles: ["Bíceps", "Ombros"],
        movementPattern: "Puxar horizontal",
        equipment: ["Máquina", "Cabo"],
        difficulty: "Iniciante",
        instructions: "Sente-se na máquina, segure o puxador triângulo. Puxe a carga em direção ao abdômen mantendo a coluna ereta e cotovelos fechados.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["remada_curvada_barra", "remada_unilateral_halter"],
        tags: ["costas", "espessura"],
    },
    {
        id: "puxada_triangulo",
        name: "Puxada alta com triângulo",
        category: "Costas",
        primaryMuscles: ["Costas"],
        secondaryMuscles: ["Bíceps", "Antebraço"],
        movementPattern: "Puxar vertical",
        equipment: ["Cabo", "Máquina"],
        difficulty: "Iniciante",
        instructions: "Puxe o triângulo em direção ao peito mantendo o tronco estável e cotovelos próximos ao corpo.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["puxada_alta_pronada", "barra_fixa"],
        tags: ["costas", "dorsal", "máquina"],
    },
    {
        id: "remada_unilateral_halter",
        name: "Remada unilateral com halter",
        category: "Costas",
        primaryMuscles: ["Costas"],
        secondaryMuscles: ["Bíceps", "Core"],
        movementPattern: "Puxar horizontal",
        equipment: ["Halteres", "Banco"],
        difficulty: "Intermediário",
        instructions: "Apoie uma mão no banco, mantenha coluna neutra e puxe o halter com o cotovelo em direção ao quadril.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["remada_baixa_triangulo", "remada_curvada_barra"],
        tags: ["costas", "unilateral", "halteres"],
    },
    {
        id: "remada_curvada_barra",
        name: "Remada curvada com barra",
        category: "Costas",
        primaryMuscles: ["Costas"],
        secondaryMuscles: ["Bíceps", "Core", "Lombar"],
        movementPattern: "Puxar horizontal",
        equipment: ["Barra"],
        difficulty: "Avançado",
        instructions: "Incline o tronco à frente a 45 graus, mantenha a lombar firme. Puxe a barra em direção ao umbigo puxando com os cotovelos.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["remada_curvada_halteres", "remada_cavalinho"],
        tags: ["costas", "força", "core"],
    },
    // PERNAS (Legs)
    {
        id: "agachamento_livre_barra",
        name: "Agachamento livre com barra",
        category: "Quadríceps",
        primaryMuscles: ["Quadríceps", "Glúteos"],
        secondaryMuscles: ["Posterior", "Core", "Lombar"],
        movementPattern: "Extensão de joelho",
        equipment: ["Barra"],
        difficulty: "Avançado",
        instructions: "Apoie a barra nos trapézios. Agache projetando o quadril para trás e descendo até a coxa ficar paralela ao chão.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["agachamento_smith", "leg_press_45"],
        tags: ["pernas", "força", "hipertrofia"],
    },
    {
        id: "leg_press_45",
        name: "Leg Press 45 graus",
        category: "Quadríceps",
        primaryMuscles: ["Quadríceps", "Glúteos"],
        secondaryMuscles: ["Posterior"],
        movementPattern: "Extensão de joelho",
        equipment: ["Máquina"],
        difficulty: "Iniciante",
        instructions: "Posicione os pés na plataforma na largura dos ombros. Destrave a plataforma e flexione os joelhos a 90 graus com cuidado, empurre sem travar os joelhos no topo.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["agachamento_hack", "agachamento_livre_barra"],
        tags: ["pernas", "hipertrofia"],
    },
    {
        id: "agachamento_smith",
        name: "Agachamento no Smith",
        category: "Quadríceps",
        primaryMuscles: ["Quadríceps", "Glúteos"],
        secondaryMuscles: ["Posterior", "Core"],
        movementPattern: "Extensão de joelho",
        equipment: ["Smith"],
        difficulty: "Intermediário",
        instructions: "Posicione a barra no trapézio, ajuste os pés à frente do corpo e agache controlando a descida.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["agachamento_livre_barra", "leg_press_45"],
        tags: ["pernas", "smith", "hipertrofia"],
    },
    {
        id: "mesa_flexora",
        name: "Mesa flexora",
        category: "Posterior",
        primaryMuscles: ["Posterior"],
        secondaryMuscles: ["Panturrilha"],
        movementPattern: "Flexão de joelho",
        equipment: ["Máquina"],
        difficulty: "Iniciante",
        instructions: "Ajuste o rolo próximo ao calcanhar. Flexione os joelhos contraindo posteriores e retorne sem perder controle.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["levantamento_terra_romeno"],
        tags: ["posterior", "máquina", "isolado"],
    },
    {
        id: "levantamento_terra_romeno",
        name: "Stiff / Levantamento Terra Romeno",
        category: "Posterior",
        primaryMuscles: ["Posterior", "Glúteos"],
        secondaryMuscles: ["Lombar", "Core"],
        movementPattern: "Flexão de quadril",
        equipment: ["Barra", "Halteres"],
        difficulty: "Intermediário",
        instructions: "Em pé, segure a barra. Desça a barra rente às pernas flexionando levemente os joelhos e empurrando o quadril para trás até sentir alongar os posteriores.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["mesa_flexora", "levantamento_terra_convencional"],
        tags: ["posterior", "gluteos", "força"],
    },
    // OMBROS (Shoulders)
    {
        id: "desenvolvimento_halteres",
        name: "Desenvolvimento com halteres",
        category: "Ombros",
        primaryMuscles: ["Ombros"],
        secondaryMuscles: ["Tríceps"],
        movementPattern: "Empurrar vertical",
        equipment: ["Halteres", "Banco"],
        difficulty: "Intermediário",
        instructions: "Sente-se no banco, eleve os halteres na altura das orelhas e empurre-os para cima até estender os braços de forma controlada.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["desenvolvimento_barra", "desenvolvimento_maquina"],
        tags: ["ombros", "deltoide"],
    },
    {
        id: "elevacao_lateral_halteres",
        name: "Elevação lateral com halteres",
        category: "Ombros",
        primaryMuscles: ["Ombros"],
        secondaryMuscles: [],
        movementPattern: "Isolado Ombros",
        equipment: ["Halteres"],
        difficulty: "Iniciante",
        instructions: "Em pé, eleve os braços lateralmente com cotovelos levemente flexionados até a altura dos ombros e retorne de forma lenta.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["elevacao_lateral_polia", "elevacao_lateral_maquina"],
        tags: ["ombros", "deltoide lateral"],
    },
    {
        id: "desenvolvimento_maquina",
        name: "Desenvolvimento na máquina",
        category: "Ombros",
        primaryMuscles: ["Ombros"],
        secondaryMuscles: ["Tríceps"],
        movementPattern: "Empurrar vertical",
        equipment: ["Máquina"],
        difficulty: "Iniciante",
        instructions: "Ajuste o banco para as manoplas ficarem na linha dos ombros. Empurre para cima e controle a descida.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["desenvolvimento_halteres"],
        tags: ["ombros", "máquina", "iniciante"],
    },
    // BRAÇOS (Arms)
    {
        id: "rosca_direta_barra",
        name: "Rosca direta com barra W",
        category: "Bíceps",
        primaryMuscles: ["Bíceps"],
        secondaryMuscles: ["Antebraço"],
        movementPattern: "Isolado Bíceps",
        equipment: ["Barra"],
        difficulty: "Iniciante",
        instructions: "Segure a barra W de forma supinada. Flexione os cotovelos subindo a barra sem movimentar os ombros.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["rosca_direta_halteres", "rosca_martelo"],
        tags: ["biceps", "braco"],
    },
    {
        id: "triceps_polia_barra",
        name: "Tríceps na polia com barra reta",
        category: "Tríceps",
        primaryMuscles: ["Tríceps"],
        secondaryMuscles: [],
        movementPattern: "Isolado Tríceps",
        equipment: ["Cabo", "Máquina"],
        difficulty: "Iniciante",
        instructions: "Segure a barra reta ligada à polia alta. Empurre a barra para baixo mantendo os cotovelos fixados na lateral do tronco.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["triceps_polia_corda", "triceps_testa"],
        tags: ["triceps", "braco"],
    },
    {
        id: "rosca_martelo",
        name: "Rosca martelo",
        category: "Bíceps",
        primaryMuscles: ["Bíceps", "Antebraço"],
        secondaryMuscles: [],
        movementPattern: "Isolado Bíceps",
        equipment: ["Halteres"],
        difficulty: "Iniciante",
        instructions: "Segure os halteres com pegada neutra e flexione os cotovelos sem balançar o tronco.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["rosca_direta_barra"],
        tags: ["biceps", "antebraço", "halteres"],
    },
    {
        id: "triceps_polia_corda",
        name: "Tríceps na polia com corda",
        category: "Tríceps",
        primaryMuscles: ["Tríceps"],
        secondaryMuscles: [],
        movementPattern: "Isolado Tríceps",
        equipment: ["Cabo", "Máquina"],
        difficulty: "Iniciante",
        instructions: "Empurre a corda para baixo mantendo cotovelos fixos e abra levemente as pontas ao final do movimento.",
        videoUrl: "",
        imageUrl: "",
        alternatives: ["triceps_polia_barra", "triceps_testa"],
        tags: ["triceps", "corda", "cabo"],
    },
];

export const getStrengthExerciseById = (exerciseId) =>
    STRENGTH_EXERCISE_LIBRARY.find(exercise => exercise.id === exerciseId);

export const buildStrengthWorkoutSetFromExercise = (exercise = {}, overrides = {}) => ({
    type: "strength_exercise",
    exercise: exercise.name || "",
    exerciseId: exercise.id || "",
    strengthMethod: "straight",
    sets: 3,
    reps: "12",
    load: "",
    rest: "60s",
    muscleGroup: exercise.primaryMuscles?.[0] || exercise.category || "",
    primaryMuscles: exercise.primaryMuscles || [],
    secondaryMuscles: exercise.secondaryMuscles || [],
    equipment: exercise.equipment?.[0] || "",
    description: exercise.instructions || "",
    instructions: exercise.instructions || "",
    alternatives: exercise.alternatives || [],
    tempo: "",
    ...overrides,
});
